import React from "react";
import Fields from "../../../containers/generics/fields";

const SectionsForm = (props)=>{
    return(
        props.sections.map((section, i)=>       
            <fieldset key={i}>
                <legend>{section.section_name}</legend>
                <div className='d-flex flex-wrap form-group' style={{marginTop:10}}>
                    {section.fields.map((field, j)=>
                        <Fields 
                            key={j} 
                            {...props} 
                            field={field} 
                            section={i} 
                            index={j}
                            updateForm={props.updateForm}
                        />
                    )}
                </div>
            </fieldset>
        )
    )
}

export default SectionsForm;